import { useMemo } from 'react';

import { useLocale } from 'state/intl';
import { IGetConfigValueProps, getConfigValue } from 'utils/environment';

type IUseConfigValueProps = Pick<IGetConfigValueProps, 'key' | 'defaultValue'> & {
  isRegionalized?: boolean;
};

export const useConfigValue = ({
  key,
  defaultValue = '',
  isRegionalized = true,
}: IUseConfigValueProps) => {
  const { region } = useLocale();

  const value = useMemo(() => {
    if (isRegionalized) {
      return getConfigValue({ key, region, defaultValue });
    }
    return getConfigValue({ key, defaultValue });
  }, [defaultValue, isRegionalized, key, region]);

  return value;
};
